import { render, staticRenderFns } from "./ColorPalettePicker.vue?vue&type=template&id=72d6d00c&scoped=true&"
import script from "./ColorPalettePicker.vue?vue&type=script&lang=js&"
export * from "./ColorPalettePicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorPalettePicker.vue?vue&type=style&index=0&id=72d6d00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d6d00c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
installComponents(component, {VColorPicker})
